"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RespondentBehaviorCharts = void 0;
/*
 * Copyright 2025, Polytechnique Montreal and contributors
 *
 * This file is licensed under the MIT License.
 * License text available at https://opensource.org/licenses/MIT
 */
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const HashLoader_1 = __importDefault(require("react-spinners/HashLoader"));
const DropoutAnalysis_1 = __importDefault(require("./DropoutAnalysis"));
const Status = __importStar(require("chaire-lib-common/lib/utils/Status"));
// Main respondent behavior page: fetches metrics once and renders multiple collapsible sections
const RespondentBehaviorCharts = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [metrics, setMetrics] = react_1.default.useState(undefined);
    const [errorKey, setErrorKey] = react_1.default.useState(null);
    const [loading, setLoading] = react_1.default.useState(true);
    react_1.default.useEffect(() => {
        const abortController = new AbortController();
        setLoading(true);
        setErrorKey(null);
        // Fetch the metrics from the API endpoint (single fetch used by all sections)
        fetch('/api/admin/data/widgets/respondent-behavior-metrics', {
            method: 'POST',
            body: JSON.stringify({ refreshCache: false }),
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            signal: abortController.signal
        })
            .then((response) => {
            if (response.status === 200) {
                return response.json();
            }
            throw new Error(`HTTP ${response.status}`);
        })
            .then((jsonData) => {
            if (Status.isStatusOk(jsonData)) {
                setMetrics(Status.unwrap(jsonData));
            }
            else {
                setErrorKey('admin:monitoring.errors.invalidResponse');
                console.error(t('admin:monitoring.errors.invalidResponse'), jsonData);
            }
        })
            .catch((err) => {
            if (err.name === 'AbortError')
                return;
            setErrorKey('admin:monitoring.errors.fetchError');
            console.error(t('admin:monitoring.errors.fetchError'), err);
        })
            .finally(() => {
            if (!abortController.signal.aborted)
                setLoading(false);
        });
        return () => abortController.abort();
    }, []);
    return (react_1.default.createElement("section", { className: "monitoring-section" },
        react_1.default.createElement("h2", null, t('admin:monitoring.RespondentBehavior.sectionTitle')),
        errorKey ? (react_1.default.createElement("div", { className: "monitoring-error" }, t(errorKey))) : loading ? (react_1.default.createElement("div", { className: "monitoring-loading-container" },
            react_1.default.createElement(HashLoader_1.default, { size: '30px', color: '#aaaaaa', loading: true }))) : (react_1.default.createElement("div", { className: "monitoring-charts-container" }, metrics && react_1.default.createElement(DropoutAnalysis_1.default, { data: metrics })))));
};
exports.RespondentBehaviorCharts = RespondentBehaviorCharts;
//# sourceMappingURL=RespondentBehaviorCharts.js.map